// extracted by mini-css-extract-plugin
export default {"toolbarWrapper":"styles_toolbarWrapper__bwtwu","toolbarText":"styles_toolbarText__pZK7j","toolbarLogo":"styles_toolbarLogo__sD9yI"};